import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Logo from './Logo';
import { FaSpinner } from 'react-icons/fa';
import { loadScript } from '../utils/loadScript'; // Ensure this path is correct

const apartmentsData = [
  {
    name: 'Castle Creek',
    officeHours: [
      { days: 'Mon - Thu', hours: '9-5' },
      { days: 'Fri', hours: '9-4' },
      { days: 'Sat - Sun', hours: 'Closed' },
    ],
    address: {
      street: '5200 Nob Hill Blvd.',
      city: 'Yakima, WA 98908',
      googleMapsUrl:
        'https://www.google.com/maps/search/?api=1&query=Castle+Creek+Apartment,5200+Nob+Hill+Blvd,+Yakima,+WA+98908',
      phone: '509-965-4057',
    },
    mapSrc:
      'https://www.google.com/maps/embed/v1/place?key=AIzaSyA6LrH1iVT9OUZUNSTyI9SOxusM4imd1SY&q=Castle+Creek+Apartment,5200+W+Nob+Hill+Blvd,+Yakima,+WA+98908',
  },
  {
    name: 'University Parkway',
    officeHours: [
      { days: 'Mon - Thu', hours: '9-5' },
      { days: 'Fri', hours: '9-4' },
      { days: 'Sat - Sun', hours: 'Closed' },
    ],
    address: {
      street: '500 University Parkway',
      city: 'Yakima, WA 98901',
      googleMapsUrl:
        'https://www.google.com/maps/search/?api=1&query=University+Parkway+Apartments,500+University+Parkway,+Yakima,+WA+98901',
      phone: '509-823-4387',
    },
    mapSrc:
      'https://www.google.com/maps/embed/v1/place?key=AIzaSyA6LrH1iVT9OUZUNSTyI9SOxusM4imd1SY&q=University+Parkway+Apartments,500+University+Parkway,+Yakima,+WA+98901',
  },
  {
    name: 'Lake Aspen',
    officeHours: [
      { days: 'Mon - Fri', hours: '8-5' },
      { days: 'Sat - Sun', hours: 'Closed' },
    ],
    address: {
      street: '1725 River Road',
      city: 'Yakima, WA 98902',
      googleMapsUrl:
        'https://www.google.com/maps/search/?api=1&query=Lake+Aspen,1725+River+Road,+Yakima,+WA+98902',
      phone: '509-248-5351',
    },
    mapSrc:
      'https://www.google.com/maps/embed/v1/place?key=AIzaSyA6LrH1iVT9OUZUNSTyI9SOxusM4imd1SY&q=Lake+Aspen,1725+River+Road,+Yakima,+WA+98902',
  },
  {
    name: 'The Lodges',
    officeHours: [
      { days: 'Mon - Thu', hours: '9-5' },
      { days: 'Fri', hours: '9-4' },
      { days: 'Sat - Sun', hours: 'Closed' },
    ],
    address: {
      street: '901 South 72nd Ave',
      city: 'Yakima, WA 98908',
      googleMapsUrl:
        'https://www.google.com/maps/search/?api=1&query=The+Lodges,901+South+72nd+Ave,+Yakima,+WA+98908',
      phone: '509-902-8958',
    },
    mapSrc:
      'https://www.google.com/maps/embed/v1/place?key=AIzaSyA6LrH1iVT9OUZUNSTyI9SOxusM4imd1SY&q=The+Lodges,901+South+72nd+Ave,+Yakima,+WA+98908',
  },
  {
    name: 'Powerhouse Flats',
    officeHours: [
      { days: 'Mon - Thu', hours: '9-5' },
      { days: 'Fri', hours: '9-4' },
      { days: 'Sat - Sun', hours: 'Closed' },
    ],
    address: {
      street: '4401 W Powerhouse Rd.',
      city: 'Yakima, WA 98908',
      googleMapsUrl:
        'https://www.google.com/maps/search/?api=1&query=Powerhouse+Flats,4401+W+Powerhouse+Rd,+Yakima,+WA+98908',
      phone: '509-342-7907',
    },
    mapSrc:
      'https://www.google.com/maps/embed/v1/place?key=AIzaSyA6LrH1iVT9OUZUNSTyI9SOxusM4imd1SY&q=Powerhouse+Flats,4401+W+Powerhouse+Rd,+Yakima,+WA+98908',
  },
];

const apartments = apartmentsData.map((apartment) => apartment.name);

function getApartmentData(name) {
  return apartmentsData.find((apartment) => apartment.name === name);
}

const ContactForm = ({ preselectedApartment }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    apartment: preselectedApartment || '',
    turnstileToken: '',
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Update 'apartment' in formData if 'preselectedApartment' prop changes
  useEffect(() => {
    if (preselectedApartment) {
      setFormData((prev) => ({ ...prev, apartment: preselectedApartment }));
    }
  }, [preselectedApartment]);

  // Load Turnstile script once when the component mounts
  useEffect(() => {
    loadScript('https://challenges.cloudflare.com/turnstile/v0/api.js')
      .then(() => {
        console.log('Turnstile script loaded');
        // Render Turnstile widget
        if (window.turnstile) {
          window.turnstile.render('#turnstile-container', {
            sitekey: '0x4AAAAAAAw6bbwWu6SWhYea', // Your Site Key
            callback: (token) => {
              setFormData((prev) => ({ ...prev, turnstileToken: token }));
              if (errors.turnstileToken) {
                setErrors((prev) => ({ ...prev, turnstileToken: '' }));
              }
            },
            'error-callback': () => {
              setErrors((prev) => ({
                ...prev,
                turnstileToken: 'Captcha verification failed.',
              }));
            },
            'expired-callback': () => {
              setFormData((prev) => ({ ...prev, turnstileToken: '' }));
              setErrors((prev) => ({
                ...prev,
                turnstileToken: 'Captcha expired. Please verify again.',
              }));
            },
          });
        }
      })
      .catch((err) => {
        console.error('Error loading Turnstile script:', err);
      });
  }, []); // Empty dependency array to run only once

  // Validation functions
  const validate = () => {
    const newErrors = {};

    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required.';
    } else if (!/^[A-Za-z\s]+$/.test(formData.name.trim())) {
      newErrors.name = 'Name can only contain letters and spaces.';
    }

    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required.';
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email.trim())
    ) {
      newErrors.email = 'Invalid email address.';
    }

    // Phone validation
    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone number is required.';
    } else if (!/^(\+\d{1,3}[- ]?)?\d{10}$/.test(formData.phone.trim())) {
      newErrors.phone = 'Invalid phone number. Enter 10 digits.';
    }

    // Message validation
    if (!formData.message.trim()) {
      newErrors.message = 'Message is required.';
    } else if (formData.message.trim().length < 10) {
      newErrors.message = 'Message must be at least 10 characters.';
    }

    // Apartment validation
    if (!formData.apartment) {
      newErrors.apartment = 'Please select an apartment.';
    }

    // Turnstile validation
    if (!formData.turnstileToken) {
      newErrors.turnstileToken = 'Please verify that you are not a robot.';
    }

    setErrors(newErrors);

    // If no errors, return true
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    // Remove error message as user types
    if (errors[e.target.name]) {
      setErrors({
        ...errors,
        [e.target.name]: '',
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError('');

    if (!validate()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await axios.post(
        'https://mail.rentyakima.com/api/contact',
        formData,
        {
          headers: {
            'x-api-key': 'sWEvz2fcAeG6ZlAfwRvQDMX8Tn5aaFZGqwhlv', // Add API key header here
          },
        }
      );

      if (response.status === 200) {
        setSubmitted(true);
        setFormData({
          name: '',
          email: '',
          phone: '',
          message: '',
          apartment: preselectedApartment || '',
          turnstileToken: '',
        });
        // Reset Turnstile widget
        if (window.turnstile) {
          window.turnstile.reset('#turnstile-container');
        }
      } else {
        setSubmitError('Something went wrong. Please try again later.');
      }
    } catch (err) {
      setSubmitError(
        err.response?.data?.message || 'An error occurred. Please try again.'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
        <div className="bg-white p-8 rounded shadow-md text-center max-w-md w-full">
          <h2 className="text-2xl font-bold mb-4">Thank You!</h2>
          <p>
            Your message has been sent successfully. We will get back to you
            shortly.
          </p>
          <button
            className="mt-6 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            onClick={() => setSubmitted(false)}
          >
            Send Another Message
          </button>
        </div>
      </div>
    );
  }

  const selectedApartmentData = getApartmentData(formData.apartment);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="max-w-6xl w-full bg-white p-6 rounded shadow-md">
        <h2 className="text-3xl font-bold mb-6 text-center">Contact Us</h2>
        <div className="flex flex-col lg:flex-row lg:space-x-6">
          {/* Information Card */}
          <div className="lg:w-1/2 bg-gray-50 p-6 rounded shadow mb-6 lg:mb-0">
            {/* Logo */}
            <div className="mb-6">
              <Logo apartment={formData.apartment} />
            </div>

            {/* Office Hours and Address in Split Columns */}
            <div className="flex flex-col md:flex-row md:space-x-6">
              {/* Office Hours */}
              {selectedApartmentData && selectedApartmentData.officeHours && (
                <div className="mb-6 md:mb-0 md:w-1/2">
                  <h3 className="text-gray-700 font-bold mb-2">
                    Office Hours:
                  </h3>
                  <div className="text-gray-600">
                    {selectedApartmentData.officeHours.map((item, index) => (
                      <p key={index}>
                        {item.days}: {item.hours}
                      </p>
                    ))}
                  </div>
                </div>
              )}

              {/* Address */}
              {selectedApartmentData && selectedApartmentData.address && (
                <div className="mb-6 md:mb-0 md:w-1/2">
                  <h3 className="text-gray-700 font-bold mb-2">Address:</h3>
                  <div className="text-gray-600">
                    <address>
                      <a
                        href={
                          selectedApartmentData.address.googleMapsUrl
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 underline block"
                      >
                        <p>{selectedApartmentData.address.street}</p>
                        <p>{selectedApartmentData.address.city}</p>
                      </a>
                      <div className="mt-2">
                        <strong>Phone:</strong>
                        <p>
                          <a
                            href={`tel:${selectedApartmentData.address.phone}`}
                            className="text-blue-500 underline"
                          >
                            {selectedApartmentData.address.phone}
                          </a>
                        </p>
                      </div>
                    </address>
                  </div>
                </div>
              )}
            </div>

            {/* Google Map */}
            {selectedApartmentData && selectedApartmentData.mapSrc && (
              <div className="mt-6">
                <iframe
                  title="Google Map"
                  className="w-full h-48 md:h-64"
                  frameBorder="0"
                  style={{ border: 0 }}
                  src={selectedApartmentData.mapSrc}
                  allowFullScreen
                ></iframe>
              </div>
            )}
          </div>

          {/* Form Card */}
          <div className="lg:w-1/2 bg-white p-6 rounded shadow">
            <form onSubmit={handleSubmit} noValidate>
              {/* Apartment Field */}
              <div className="mb-4">
                <label htmlFor="apartment" className="block text-gray-700">
                  Apartment<span className="text-red-500">*</span>
                </label>
                <select
                  id="apartment"
                  name="apartment"
                  value={formData.apartment}
                  onChange={handleChange}
                  aria-invalid={errors.apartment ? 'true' : 'false'}
                  aria-describedby={
                    errors.apartment ? 'apartment-error' : null
                  }
                  className={`mt-1 p-2 w-full border ${
                    errors.apartment
                      ? 'border-red-500'
                      : 'border-gray-300'
                  } rounded bg-white`}
                >
                  <option value="">Select an Apartment</option>
                  {apartments.map((apt) => (
                    <option key={apt} value={apt}>
                      {apt}
                    </option>
                  ))}
                </select>
                {errors.apartment && (
                  <p
                    className="text-red-500 text-sm mt-1"
                    id="apartment-error"
                  >
                    {errors.apartment}
                  </p>
                )}
              </div>

              {/* Name Field */}
              <div className="mb-4">
                <label htmlFor="name" className="block text-gray-700">
                  Name<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Please enter your name"
                  value={formData.name}
                  onChange={handleChange}
                  aria-invalid={errors.name ? 'true' : 'false'}
                  aria-describedby={errors.name ? 'name-error' : null}
                  className={`mt-1 p-2 w-full border ${
                    errors.name ? 'border-red-500' : 'border-gray-300'
                  } rounded`}
                />
                {errors.name && (
                  <p
                    className="text-red-500 text-sm mt-1"
                    id="name-error"
                  >
                    {errors.name}
                  </p>
                )}
              </div>

              {/* Email Field */}
              <div className="mb-4">
                <label htmlFor="email" className="block text-gray-700">
                  Email<span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Please enter your email"
                  value={formData.email}
                  onChange={handleChange}
                  aria-invalid={errors.email ? 'true' : 'false'}
                  aria-describedby={errors.email ? 'email-error' : null}
                  className={`mt-1 p-2 w-full border ${
                    errors.email
                      ? 'border-red-500'
                      : 'border-gray-300'
                  } rounded`}
                />
                {errors.email && (
                  <p
                    className="text-red-500 text-sm mt-1"
                    id="email-error"
                  >
                    {errors.email}
                  </p>
                )}
              </div>

              {/* Phone Field */}
              <div className="mb-4">
                <label htmlFor="phone" className="block text-gray-700">
                  Phone<span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  placeholder="Please enter your phone number"
                  value={formData.phone}
                  onChange={handleChange}
                  aria-invalid={errors.phone ? 'true' : 'false'}
                  aria-describedby={errors.phone ? 'phone-error' : null}
                  className={`mt-1 p-2 w-full border ${
                    errors.phone
                      ? 'border-red-500'
                      : 'border-gray-300'
                  } rounded`}
                />
                {errors.phone && (
                  <p
                    className="text-red-500 text-sm mt-1"
                    id="phone-error"
                  >
                    {errors.phone}
                  </p>
                )}
              </div>

              {/* Message Field */}
              <div className="mb-4">
                <label htmlFor="message" className="block text-gray-700">
                  Message<span className="text-red-500">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Your message..."
                  value={formData.message}
                  onChange={handleChange}
                  aria-invalid={errors.message ? 'true' : 'false'}
                  aria-describedby={
                    errors.message ? 'message-error' : null
                  }
                  className={`mt-1 p-2 w-full border ${
                    errors.message
                      ? 'border-red-500'
                      : 'border-gray-300'
                  } rounded`}
                  rows="4"
                ></textarea>
                {errors.message && (
                  <p
                    className="text-red-500 text-sm mt-1"
                    id="message-error"
                  >
                    {errors.message}
                  </p>
                )}
              </div>

              {/* Turnstile Captcha */}
              <div className="mb-4">
                <label className="block text-gray-700">
                  Captcha<span className="text-red-500">*</span>
                </label>
                <div id="turnstile-container"></div>
                {errors.turnstileToken && (
                  <p
                    className="text-red-500 text-sm mt-1"
                    id="captcha-error"
                  >
                    {errors.turnstileToken}
                  </p>
                )}
              </div>

              {/* Submission Error */}
              {submitError && (
                <div className="mb-4">
                  <p className="text-red-500 text-sm text-center">
                    {submitError}
                  </p>
                </div>
              )}

              {/* Submit Button */}
              <div>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`w-full px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 flex items-center justify-center ${
                    isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                  }`}
                >
                  {isSubmitting ? (
                    <>
                      <FaSpinner className="animate-spin mr-2" />
                      Sending...
                    </>
                  ) : (
                    'Send Message'
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
